import React from 'react';
import { Link } from 'react-router-dom';

import {
  Title,
  Text,
  BackLink,
} from '../styles';

const Success = () => (
  <>
    <Title>You&apos;re almost there!</Title>

    <Text>
      We&apos;ve sent you an email to reset your password.
      If you haven&apos;t received it within 5 minutes,
      please check your spam and promotions folder.
    </Text>
    <BackLink>
      <Link to="/">Return to login</Link>
    </BackLink>
  </>
);

export default Success;
